import { emptySplitApi as api } from "./baseApi";

export interface BusinessUnit {
  id?: string;
  name: string;
  description?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export const addTagTypes = ["BusinessUnitController"] as const;

const businessUnitApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      // Get all business units
      getBusinessUnits: build.query<BusinessUnit[], void>({
        query: () => ({ url: `/business-units` }),
        providesTags: ["BusinessUnitController"],
      }),

      // Get active business units (sorted)
      getActiveBusinessUnits: build.query<BusinessUnit[], void>({
        query: () => ({ url: `/business-units/active` }),
        providesTags: ["BusinessUnitController"],
      }),

      // Get business unit by ID
      getBusinessUnitById: build.query<BusinessUnit, { id: string }>({
        query: (queryArg) => ({ url: `/business-units/${queryArg.id}` }),
        providesTags: ["BusinessUnitController"],
      }),

      // Create business unit
      createBusinessUnit: build.mutation<BusinessUnit, Partial<BusinessUnit>>({
        query: (body) => ({
          url: `/business-units`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),

      // Update business unit
      updateBusinessUnit: build.mutation<void, { id: string; body: Partial<BusinessUnit> }>({
        query: (queryArg) => ({
          url: `/business-units/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),

      // Delete business unit
      deleteBusinessUnit: build.mutation<void, { id: string }>({
        query: (queryArg) => ({
          url: `/business-units/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),

      // Seed default business units
      seedBusinessUnits: build.mutation<{ created: number; skipped: number }, void>({
        query: () => ({
          url: `/business-units/seed-defaults`,
          method: "POST",
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),
    }),
  });

export { businessUnitApi };

export const {
  useGetBusinessUnitsQuery,
  useGetActiveBusinessUnitsQuery,
  useGetBusinessUnitByIdQuery,
  useCreateBusinessUnitMutation,
  useUpdateBusinessUnitMutation,
  useDeleteBusinessUnitMutation,
  useSeedBusinessUnitsMutation,
} = businessUnitApi;
